import { CSSProperties } from "@material-ui/core/styles/withStyles";
import {
  fontFamily,
  fontFamilySans,
  weight,
  size,
} from "@clockwise/web-commons/src/styles/type.styles";
import { greys, colors, helpers } from "@clockwise/web-commons/src/styles/color.styles";
import { darken } from "@clockwise/client-commons/src/util/color";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

const config = {
  headerHeight: 560,
  navHeight: 70,
  btnHeight: 50,
  splashHWRatio: 0.65,
};

const headerContainer: CSSProperties = {
  fontFamily,
  position: "relative",
  paddingTop: config.navHeight,
  paddingLeft: 30,
  paddingRight: 30,
  zIndex: 3,
  background: greys.palePaleGrey,
};

const headerContent: CSSProperties = {
  zIndex: 5,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  "@media (max-width: 750px)": {
    paddingTop: 50,
  },
  "@media (max-width: 400px)": {
    paddingTop: 30,
    paddingBottom: 30,
  },
};

const h1: CSSProperties = {
  fontFamily,
  fontSize: 32,
  fontWeight: weight.bold,
  color: colors.blueDusk.darker,
  textAlign: "center",
  marginBottom: 20,
  lineHeight: 1.2,
  "@media (max-width: 750px)": {
    maxWidth: 540,
    fontSize: 28,
  },
  "@media (max-width: 400px)": {
    marginBottom: 10,
  },
};

const h2: CSSProperties = {
  maxWidth: 500,
  marginTop: 10,
  marginBottom: 36,
  fontSize: 16,
  lineHeight: 1.6,
  fontFamily: fontFamilySans,
  fontWeight: weight.std,
  color: greys.standard,
  textAlign: "center",
  "@media (max-width: 750px)": {
    maxWidth: 450,
    fontSize: 18,
  },
  "@media (max-width: 400px)": {
    fontSize: 16,
    marginBottom: 0,
  },
};

const container: CSSProperties = {
  fontFamily,
  background: greys.palePaleGrey,
};

const buttonContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  paddingBottom: 100,
};

const buttonWarning: CSSProperties = {
  background: colors.red.standard,
  "&:hover": {
    background: helpers.opacity(colors.red.standard, 0.8),
  },
};

const buttonWarningRippleRoot: CSSProperties = {
  color: darken(colors.red.standard, 0.1),
};

const buttonCancel: CSSProperties = {
  background: greys.white,
};

const buttonLabel: CSSProperties = {
  color: greys.white,
};

const loginContainer: CSSProperties = {
  fontWeight: weight.std,
  color: greys.standard,
  paddingBottom: 50,
  width: "fit-content",
  margin: "0 auto",
};

const deactivateContainer: CSSProperties = {
  fontWeight: weight.std,
  color: greys.standard,
  paddingBottom: 50,
};

export const deactivateButton: CSSProperties = {
  height: 45,
  lineHeight: `45px`,
  width: "100%",
};

export const deactivateButtonLabel: CSSProperties = {
  fontFamily: fontFamilySans,
  fontSize: size.md,
  paddingLeft: spacing.std,
  paddingRight: spacing.lg,
  color: greys.white,
  textTransform: "none",
};

export const greyBorder = `1px solid ${greys.blueGrey}`;

export const survey = {
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 36,
  } as CSSProperties,
  paper: {
    padding: "40px 40px 20px",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: 1,
    maxWidth: 650,
    margin: "0 20px 0 20px",
  } as CSSProperties,
  h1: {
    fontSize: 24,
    paddingBottom: 40,
  },
  section: {
    paddingBottom: 40,
  } as CSSProperties,
  text: {
    fontSize: 16,
    fontWeight: weight.std,
    color: greys.dark,
    "@media (max-width: 750px)": {
      fontSize: 14,
      color: greys.slate,
    },
  } as CSSProperties,
  button: {
    width: 120,
    marginBottom: 30,
  } as CSSProperties,
};

export const iframe = {
  container: {
    // top: -170,
    // position: 'relative',
    // paddingLeft: 8,
  } as CSSProperties,
  frame: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    zIndex: 2,
  } as CSSProperties,
};

export const radioRoot = {
  "&$checked": {
    color: colors.green.standard,
  },
};

export const styles = {
  container,
  headerContainer,
  headerContent,
  h1,
  h2,
  buttonContainer,
  buttonWarning,
  buttonWarningRippleRoot,
  buttonCancel,
  buttonLabel,
  deactivateContainer,
  deactivateButton,
  deactivateButtonLabel,
  radioRoot,
  loginContainer,
};
